export class FRFloor {
  id?: number | null;

  tourId: number;

  floor: number;

  active: boolean; // range rendering distance

  updatedAt?: string;

  position: any;

  sweeps: any[];

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.tourId = model.tourId;
    this.floor = model.floor;
    this.active = typeof model.active === 'boolean' ? model.active : true;
    this.updatedAt = model.updatedAt;
    this.position = model.position;
    this.sweeps = model.sweeps || [];
  }
}
